import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useDispatch, useSelector } from 'react-redux';
import { selectFirstBuyerInfo } from '../../redux-state/selectors';
import { UPDATE_FIRST_BUYER_INFO } from '../../redux-state/forms/types';

function FirstBuyerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(true);
  const firstBuyerInfo = useSelector(selectFirstBuyerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_FIRST_BUYER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">First Buyer Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer First Name"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerFirstName}
              onChange={(e) => handleChange('buyerFirstName', e.target.value)}
            />
            <TextField
              label="Buyer Middle Name"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerMiddleName}
              onChange={(e) => handleChange('buyerMiddleName', e.target.value)}
            />
            <TextField
              label="Buyer Last Name"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerLastName}
              onChange={(e) => handleChange('buyerLastName', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer Company Name"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerCompanyName}
              onChange={(e) => handleChange('buyerCompanyName', e.target.value)}
            />
            <TextField
              label="Buyer Address Line 1"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerAddressLine1}
              onChange={(e) => handleChange('buyerAddressLine1', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer Address Line 2"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerAddressLine2}
              onChange={(e) => handleChange('buyerAddressLine2', e.target.value)}
            />
            <TextField
              label="Buyer City"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerCity}
              onChange={(e) => handleChange('buyerCity', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer State"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerState}
              onChange={(e) => handleChange('buyerState', e.target.value)}
            />
            <TextField
              label="Buyer Zip"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerZip}
              onChange={(e) => handleChange('buyerZip', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={firstBuyerInfo?.buyerDob}
              onChange={(e) => handleChange('buyerDob', e.target.value)}
            />
            <TextField
              label="Buyer SSN"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerSsn}
              onChange={(e) => handleChange('buyerSsn', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Buyer Driver's License Number"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerLicenseNumber}
              onChange={(e) => handleChange('buyerLicenseNumber', e.target.value)}
            />
            <TextField
              label="Buyer Driver's License State"
              variant="outlined"
              fullWidth
              value={firstBuyerInfo?.buyerLicenseState}
              onChange={(e) => handleChange('buyerLicenseState', e.target.value)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default FirstBuyerInformation;